import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TenantSubscription, TenantSubscriptionCreate, TenantSubscriptionFilter } from '../data/tenantSubscription';

export function createTenantSubscriptionService(client: AxiosInstance) {
  return createCrudService<TenantSubscription, TenantSubscriptionCreate, TenantSubscriptionFilter>(
    client,
    '/tenancy/TenantSubscription',
    'id',
  );
}

export type TenantSubscriptionService = CrudService<TenantSubscription, TenantSubscriptionCreate, TenantSubscriptionFilter>;
